"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageTypeToDamagePercentIncrease = void 0;
const AttributeType_1 = require("../enums/AttributeType");
const DamageType_1 = require("../enums/DamageType");
exports.DamageTypeToDamagePercentIncrease = {
    [DamageType_1.DamageType.Chaos]: AttributeType_1.AttributeType.ChaosDamagePercentIncrease,
    [DamageType_1.DamageType.Death]: AttributeType_1.AttributeType.DeathDamagePercentIncrease,
    [DamageType_1.DamageType.Fire]: AttributeType_1.AttributeType.FireDamagePercentIncrease,
    [DamageType_1.DamageType.Frost]: AttributeType_1.AttributeType.FrostDamagePercentIncrease,
    [DamageType_1.DamageType.Holy]: AttributeType_1.AttributeType.HolyDamagePercentIncrease,
    [DamageType_1.DamageType.Nature]: AttributeType_1.AttributeType.NatureDamagePercentIncrease,
    [DamageType_1.DamageType.Physical]: AttributeType_1.AttributeType.PhysicalDamagePercentIncrease,
    [DamageType_1.DamageType.Sonic]: AttributeType_1.AttributeType.SonicDamagePercentIncrease,
    [DamageType_1.DamageType.None]: AttributeType_1.AttributeType.None,
    [DamageType_1.DamageType.All]: AttributeType_1.AttributeType.AllDamagePercentIncrease
};
